runOnLoad "SubscriptionWebForms", [ "new", "create", "edit", "update" ], ->

  StylesheetForm.setup()
  CloudCustomFieldManager.setup()

  # Make the custom fields section arrangeable.
  $customFieldsContainer = $(".form-custom-fields")
  $customFieldsContainer.arrangeable(".form-custom-field", "a.reorder-custom-field")
  $customFieldsContainer.on "click", "a.reorder-custom-field", ->
    Dialogs.presentModal
      header: t("modals.move_custom_field_option.header")
      body: t("modals.move_custom_field_option.body")
    return false

runOnLoad [ "SubscriptionWebForms", "ModifySubscribers" ], [ "new", "create", "edit", "update" ], ->

  # Show a dialog when users try to click on the confirmation required or send
  # thank you email links when web form delivery settings haven't yet been
  # configured.
  $(".disabled-clicker-box").on "click", ->

    $li              = $(@).closest("li")
    listName         = $li.data("list-name")
    listId           = $li.data("list-id")
    editUrl          = Routes.edit_web_form_delivery_setting_path(listId, return_to: window.location.href)
    modalHeader      = t "modals.web_form_delivery_settings_not_configured.header"
    modalBody        = t "modals.web_form_delivery_settings_not_configured.body", name: listName
    cancelText       = t "buttons.cancel"
    editSettingsText = t "buttons.edit_delivery_settings"

    modal = $("""
      <div class="modal hide fade" id="main-modal">
        <div class="modal-header">
          <a class="close" href="#" data-dismiss="modal">&times;</a>
          <h3>#{modalHeader}</h3>
        </div>

        <div class="modal-body">
          #{modalBody}
        </div>

        <div class="modal-footer">
          <a class="diminished-button button btn btn-close no-button" data-dismiss="modal" href="#">#{cancelText}</a>
          <a class="button btn btn-danger yes-button" href="#{editUrl}">#{editSettingsText}</a>
        </div>
      </div>
    """).modal("show")

    return false

runOnLoad "SubscriptionWebForms", [ "show" ], ->

  ClipboardButton.setup()
